import * as am4charts from '@amcharts/amcharts4/charts'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4plugins_forceDirected from '@amcharts/amcharts4/plugins/forceDirected'
import * as am4plugins_sunburst from '@amcharts/amcharts4/plugins/sunburst'
import * as am4plugins_wordCloud from '@amcharts/amcharts4/plugins/wordCloud'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'
import {documentModel} from 'apis/model'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import viewModes from 'conts/viewModes'
import {ROOT_URL} from 'envs/_current/config'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useEffect, useMemo, useState} from 'react'
import {useLocation, usePrevious} from 'react-use'
import {addGlobalAmChartConfig} from '../../../funcs/addGlobalAmChartConfig'
import {addWatermarkLogoConfig} from '../../../funcs/addWatermarkLogoConfig'
import {getRouteSearchParams} from "../../../../../envs/_current/history";
import {useHistory} from "../../../../../modules/navigation/useRouter";

/* Chart code */
// Themes begin
am4core.useTheme(am4themes_animated)
// Themes end

export const AmChartStateless = ({
                                   item,
                                   theme,
                                   setChartWrap,
                                   viewmode = viewModes.BLOCK,
                                   ...props
                                 }) => {
  const t = useTranslate()
  const [chart, setChart] = useState()
  const [data, setData] = useState()
  const [cParams, setCParams] = useState(null)
  const [id] = useState(_.uniqueId('chart_' + item.id))

  let searchParams = getRouteSearchParams();
  const location = useLocation()
  const history = useHistory()
  const {isSm} = useContext(LayoutContext)

  useEffect(() => {
    if (chart) return () => {
    }
    let thisChart
    let groupData = []
    let chartParams = item.params
    if (!chartParams) return () => {
    }
    chartParams = JSON.parse(JSON.stringify(chartParams))
    let data_values = []
    switch (item.chart_type) {
      case 'SortBarChart':
        thisChart = am4core.createFromConfig(
          {
            width: '100%',
            height: '100%',
            ...chartParams,
            tapToActivate: true,
            tapTimeout: 3000,
          },
          id,
          am4charts.XYChart
        )
        thisChart.padding(5, 5, 5, 5)
        thisChart.margin(5, 5, 5, 5)

        thisChart.series.values[0].columns.template.adapter.add(
          'fill',
          function (fill, target) {
            if (target.dataItem && target.dataItem.valueX < 0) {
              return '#a55'
            } else {
              return fill
            }
          }
        )

        thisChart.series.values[0].bullets.values[0].label.adapter.add(
          'dx',
          function (defValue, target) {
            return target.dataItem && target.dataItem.valueX < 0 ? -10 : 10
          }
        )
        thisChart.series.values[0].bullets.values[0].label.adapter.add(
          'horizontalCenter',
          function (defValue, target) {
            return target.dataItem && target.dataItem.valueX < 0
              ? 'right'
              : 'left'
          }
        )

        thisChart.series.values[0].columns.template.column.adapter.add(
          'cornerRadiusBottomLeft',
          function (radius, target) {
            return target.dataItem && target.dataItem.valueX < 0 ? 5 : 0
          }
        )
        thisChart.series.values[0].columns.template.column.adapter.add(
          'cornerRadiusTopLeft',
          function (radius, target) {
            return target.dataItem && target.dataItem.valueX < 0 ? 5 : 0
          }
        )
        thisChart.series.values[0].columns.template.column.adapter.add(
          'cornerRadiusBottomRight',
          function (radius, target) {
            return target.dataItem && target.dataItem.valueX < 0 ? 0 : 5
          }
        )
        thisChart.series.values[0].columns.template.column.adapter.add(
          'cornerRadiusTopRight',
          function (radius, target) {
            return target.dataItem && target.dataItem.valueX < 0 ? 0 : 5
          }
        )

        thisChart.series.values[0].bullets.values[0].label.adapter.add(
          'dx',
          function (defValue, target) {
            return target.dataItem && target.dataItem.valueX < 0 ? -10 : 10
          }
        )
        thisChart.series.values[0].bullets.values[0].label.adapter.add(
          'horizontalCenter',
          function (defValue, target) {
            return target.dataItem && target.dataItem.valueX < 0
              ? 'right'
              : 'left'
          }
        )

        addGlobalAmChartConfig(item, thisChart)

        addWatermarkLogoConfig(item, thisChart)

        thisChart.data = data_values

        break
      case 'BubbleChart':
        thisChart = am4core.createFromConfig(
          {
            width: '100%',
            height: '100%',
            ...chartParams,
            tapToActivate: true,
            tapTimeout: 3000,
          },
          id,
          am4charts.XYChart
        )
        thisChart.padding(5, 5, 5, 5)
        thisChart.margin(5, 5, 5, 5)

        thisChart.series.values[0].bullets.values[0].events.on(
          'over',
          function (event) {
            let target = event.target
            thisChart.plotContainer.children.values[0].radius =
              target.pixelRadius + 2
            thisChart.plotContainer.children.values[0].x = target.pixelX
            thisChart.plotContainer.children.values[0].y = target.pixelY
            thisChart.plotContainer.children.values[0].show()
          }
        )

        thisChart.series.values[0].bullets.values[0].adapter.add(
          'fill',
          function (fill, target) {
            return thisChart.colors.getIndex(target.dataItem.index)
          }
        )

        thisChart.series.values[0].bullets.values[0].events.on(
          'out',
          function (event) {
            thisChart.plotContainer.children.values[0].hide()
          }
        )

        let hoverState0 =
          thisChart.series.values[0].bullets.values[0].states.create('hover')
        hoverState0.properties.fillOpacity = 1
        hoverState0.properties.strokeOpacity = 1

        thisChart.series.values[0].heatRules.push({
          target: thisChart.series.values[0].bullets.values[0],
          min: 2,
          max: 60,
          property: 'radius',
        })

        thisChart.series.values[0].bullets.values[0].adapter.add(
          'tooltipY',
          function (tooltipY, target) {
            return -target.radius
          }
        )

        thisChart.series.values[0].bullets.values[1].adapter.add(
          'dy',
          function (dy, bullet) {
            if (bullet.dataItem.dataContext.showLabel == 1) {
              bullet.visible = true
              bullet.label.text = bullet.dataItem.dataContext.title
            } else {
              bullet.label.text = ''
              bullet.visible = false
            }
            return dy
          }
        )

        addGlobalAmChartConfig(item, thisChart)

        addWatermarkLogoConfig(item, thisChart)

        thisChart.data = data_values

        break
      case 'BarChartRace':
        let stepDuration1 = 4000
        let dataIndex1 = 0
        let interval1
        let group_id
        let label1
        let playButton1
        const groupByKey = _.find(item.data_columns, ['group', true])
        groupData = data_values.reduce((r, a) => {
          r[a[groupByKey.id]] = [...(r[a[groupByKey.id]] || []), a]
          return r
        }, {})

        thisChart = am4core.createFromConfig(
          {
            width: '100%',
            height: '100%',
            ...chartParams,
            tapToActivate: true,
            tapTimeout: 3000,
          },
          id,
          am4charts.XYChart
        )
        thisChart.padding(5, 5, 5, 5)
        thisChart.margin(5, 5, 5, 5)

        label1 = thisChart.plotContainer.createChild(am4core.Label)
        label1.x = am4core.percent(97)
        label1.y = am4core.percent(95)
        label1.horizontalCenter = 'right'
        label1.verticalCenter = 'middle'
        label1.dx = -15
        label1.fontSize = 50

        playButton1 = thisChart.plotContainer.createChild(am4core.PlayButton)
        playButton1.x = am4core.percent(97)
        playButton1.y = am4core.percent(95)
        playButton1.dy = -2
        playButton1.verticalCenter = 'middle'
        playButton1.events.on('toggled', function (event) {
          if (event.target.isActive) {
            play1()
          } else {
            stop1()
          }
        })

        thisChart.xAxes.values[0].rangeChangeEasing = am4core.ease.linear
        thisChart.xAxes.values[0].rangeChangeDuration = stepDuration1

        thisChart.series.values[0].interpolationDuration = stepDuration1
        thisChart.series.values[0].interpolationEasing = am4core.ease.linear

        thisChart.series.values[0].columns.template.adapter.add(
          'fill',
          function (fill, target) {
            return thisChart.colors.getIndex(target.dataItem.index)
          }
        )

        group_id = Object.keys(groupData)[dataIndex1]
        label1.text = group_id

        const play1 = () => {
          interval1 = setInterval(function () {
            nextStep1()
          }, stepDuration1)
          nextStep1()
        }

        const stop1 = () => {
          if (interval1) {
            clearInterval(interval1)
          }
        }

        const nextStep1 = () => {
          group_id = Object.keys(groupData)[dataIndex1]

          let newData = groupData[group_id]
          let itemsWithNonZero = 0
          let _data
          _data = thisChart.data || []
          for (let i = 0; i < _data.length; i++) {
            const newItem = _.find(newData, function (e) {
              return e.id.trim() === _data[i].id.trim()
            })
            if (!_.isEmpty(newItem)) {
              _data[i].value = newItem.value
            }

            if (_data[i].value > 0) {
              itemsWithNonZero++
            }
          }
          for (let i = 0; i < newData.length; i++) {
            const newItem = _.find(_data, function (e) {
              return e.id.trim() === newData[i].id.trim()
            })
            if (!_.isEmpty(newItem)) {
              thisChart.data.push(newData[i])

              itemsWithNonZero++
            }
          }

          if (dataIndex1 === 0) {
            thisChart.series.values[0].interpolationDuration = stepDuration1 / 4
            thisChart.xAxes.values[0].rangeChangeDuration = stepDuration1 / 4
          } else {
            thisChart.series.values[0].interpolationDuration = stepDuration1
            thisChart.xAxes.values[0].rangeChangeDuration = stepDuration1
          }

          thisChart.invalidateRawData()
          label1.text = group_id

          thisChart.xAxes.values[0].zoom({
            start: 0,
            end: itemsWithNonZero / thisChart.xAxes.values[0].dataItems.length,
          })

          dataIndex1++
          if (dataIndex1 >= Object.keys(groupData).length) {
            dataIndex1 = 0
            stop1()
          }
        }

        thisChart.yAxes.values[0].sortBySeries = thisChart.series.values[0]

        addGlobalAmChartConfig(item, thisChart)

        addWatermarkLogoConfig(item, thisChart)

        if (!_.isEmpty(groupData)) {
          thisChart.data = JSON.parse(JSON.stringify(groupData[group_id]))
          thisChart.xAxes.values[0].zoom({
            start: 0,
            end: 1 / thisChart.data.length,
          })
        }

        break
      case 'XYChart':
        thisChart = am4core.createFromConfig(
          {
            width: '100%',
            height: '100%',
            responsive: {
              enabled: true,
            },
            ...chartParams,
            tapToActivate: true,
            tapTimeout: 3000,
          },
          id,
          am4charts.XYChart
        )
        thisChart.padding(5, 5, 5, 5)
        thisChart.margin(5, 5, 5, 5)

        if (
          thisChart.series.values.length === 1 &&
          thisChart.series.values[0].columns &&
          thisChart.series.values[0].columns.template &&
          !(
            thisChart.series.values[0].columns.template.propertyFields &&
            thisChart.series.values[0].columns.template.propertyFields.fill
          )
        ) {
          thisChart.series.values[0].columns.template.adapter.add(
            'fill',
            function (fill, target) {
              return thisChart.colors.getIndex(target.dataItem.index)
            }
          )
        }

        addGlobalAmChartConfig(item, thisChart)

        addWatermarkLogoConfig(item, thisChart)

        // thisChart.data = data_values;

        break
      case 'Treemap':
        thisChart = am4core.createFromConfig(
          {
            width: '100%',
            height: '100%',
            responsive: {
              enabled: true,
            },
            hiddenState: {
              properties: {
                opacity: 0,
              },
            },
            colors: {
              step: 2,
            },
            dataFields: {
              value: 'value',
              name: 'name',
              children: 'children',
            },
            zoomable: false,
            ...chartParams,
            tapToActivate: true,
            tapTimeout: 3000,
          },
          id,
          am4charts.TreeMap
        )
        thisChart.padding(5, 5, 5, 5)
        thisChart.margin(5, 5, 5, 5)
        thisChart.layoutAlgorithm = thisChart.binaryTree

        // level 0 series template
        let level0SeriesTemplate = thisChart.seriesTemplates.create('0')
        let level0ColumnTemplate = level0SeriesTemplate.columns.template

        level0ColumnTemplate.column.cornerRadius(10, 10, 10, 10)
        level0ColumnTemplate.fillOpacity = 0
        level0ColumnTemplate.strokeWidth = 4
        level0ColumnTemplate.strokeOpacity = 0

        // level 1 series template
        let level1SeriesTemplate = thisChart.seriesTemplates.create('1')
        level1SeriesTemplate.tooltip.dy = -15
        level1SeriesTemplate.tooltip.pointerOrientation = 'vertical'

        let level1ColumnTemplate = level1SeriesTemplate.columns.template

        level1SeriesTemplate.tooltip.animationDuration = 0
        level1SeriesTemplate.strokeOpacity = 1

        level1ColumnTemplate.column.cornerRadius(10, 10, 10, 10)
        level1ColumnTemplate.fillOpacity = 1
        level1ColumnTemplate.strokeWidth = 4
        level1ColumnTemplate.stroke = am4core.color('#ffffff')

        let bullet1 = level1SeriesTemplate.bullets.push(
          new am4charts.LabelBullet()
        )
        bullet1.locationY = 0.5
        bullet1.locationX = 0.5
        bullet1.label.text = '{name}'
        bullet1.label.fill = am4core.color('#ffffff')
        bullet1.interactionsEnabled = false
        thisChart.maxLevels = 2

        addGlobalAmChartConfig(item, thisChart)

        addWatermarkLogoConfig(item, thisChart)

        // thisChart.data = data_values;

        break
      case 'PivotStackedColumnChart':
        let columnSeries = {
          type: 'ColumnSeries',
          id: 'id',
          name: 'name',
          dataFields: {
            valueY: 'valueY',
            categoryX: 'time',
          },
          sequencedInterpolation: true,
          stacked: true,
          columns: {
            template: {
              width: '80%',
              tooltipText:
                '[bold]{name}[/]\n[font-size:0.68rem]{categoryX}: {valueY}',
            },
          },
        }
        if (
          chartParams &&
          chartParams.series &&
          chartParams.series.length > 0
        ) {
          columnSeries = chartParams.series[0]
        }
        chartParams.series = []

        const createSeries = (chartParams, series, field) => {
          if (chartParams) {
            let _s = _.cloneDeep(series)
            _s.id = field
            _s.name = field

            if (_.has(_s, 'dataFields.valueX')) _s.dataFields.valueX = field
            if (_.has(_s, 'dataFields.valueY')) _s.dataFields.valueY = field

            chartParams.series.push(_s)
          }
        }

        _.get(item, 'data_columns', []).map((c) => {
          if (c.valueType === 'value') {
            createSeries(chartParams, columnSeries, c.id)
          }
        })

        thisChart = am4core.createFromConfig(
          {
            width: '100%',
            height: '100%',
            responsive: {
              enabled: true,
            },
            ...chartParams,
            tapToActivate: true,
            tapTimeout: 3000,
          },
          id,
          am4charts.XYChart
        )
        thisChart.padding(5, 5, 5, 5)
        thisChart.margin(5, 5, 5, 5)

        addGlobalAmChartConfig(item, thisChart)

        addWatermarkLogoConfig(item, thisChart)

        break
      case 'PivotXYChart':
        // chartParams =
        // LOOP PIVOT COLUMN TO SERIES
        if (chartParams.series && chartParams.series.length > 0) {
          let _ind = 0
          let origSeries = _.cloneDeep(chartParams.series)
          _.forEach(item.data_columns, (e, i) => {
            if (typeof e === 'object' && e.valueType === 'value') {
              let _origS = _.cloneDeep(origSeries[0])
              _origS = JSON.stringify(_origS)
              _origS = (_origS || '').replaceAll('pivot_column', e.id)
              _origS = JSON.parse(_origS)
              if (_origS.dataFields.valueX) _origS.dataFields.valueX = e.id
              if (_origS.dataFields.openValueX)
                _origS.dataFields.openValueX = e.id
              if (_origS.dataFields.valueY) _origS.dataFields.valueY = e.id
              if (_origS.dataFields.openValueY)
                _origS.dataFields.openValueY = e.id

              chartParams.series[_ind] = {
                ..._origS,
                name: e.id,
                id: 's' + _ind,
              }
              _ind += 1
            } else if (typeof e === 'object' && e.valueType === 'valueObj') {
              let _origSeries = _.cloneDeep(origSeries)
              _origSeries = JSON.stringify(_origSeries)
              _origSeries = _origSeries.replaceAll('pivot_column', e.id)
              _origSeries = JSON.parse(_origSeries)

              _.flatMap(_origSeries, (origS) => {
                let _origS = _.cloneDeep(origS)
                if (_origS.dataFields.valueX)
                  _origS.dataFields.valueX =
                    e.id + '-' + _origS.dataFields.valueX
                if (_origS.dataFields.openValueX)
                  _origS.dataFields.openValueX =
                    e.id + '-' + _origS.dataFields.openValueX
                if (_origS.dataFields.valueY)
                  _origS.dataFields.valueY =
                    e.id + '-' + _origS.dataFields.valueY
                if (_origS.dataFields.openValueY)
                  _origS.dataFields.openValueY =
                    e.id + '-' + _origS.dataFields.openValueY

                chartParams.series[_ind] = {
                  ..._origS,
                  name: e.id,
                  id: 's' + _ind,
                }
                _ind += 1
              })
            }
          })

          // setCParams(chartParams);
        }

        thisChart = am4core.createFromConfig(
          {
            width: '100%',
            height: '100%',
            responsive: {
              enabled: true,
            },
            tapToActivate: true,
            tapTimeout: 3000,
            ...chartParams,
          },
          id,
          am4charts.XYChart
        )
        thisChart.padding(5, 5, 5, 5)
        thisChart.margin(5, 5, 5, 5)

        if (
          thisChart.series.values.length === 1 &&
          thisChart.series.values[0].columns &&
          thisChart.series.values[0].columns.template
        ) {
          thisChart.series.values[0].columns.template.adapter.add(
            'fill',
            function (fill, target) {
              return thisChart.colors.getIndex(target.dataItem.index)
            }
          )
        }

        addGlobalAmChartConfig(item, thisChart)

        addWatermarkLogoConfig(item, thisChart)

        thisChart.data = data_values

        break
      case 'WordCloud':
        thisChart = am4core.createFromConfig(
          {
            // width: '100%',
            // height: '100%',
            // responsive: {
            //   enabled: true
            // },
            tapToActivate: true,
            tapTimeout: 3000,
            ...chartParams,
          },
          id,
          am4plugins_wordCloud.WordCloud
        )
        // thisChart.padding(5, 5, 5, 5)
        // thisChart.margin(5, 5, 5, 5)
        thisChart.fontFamily = 'Courier New'

        let series = thisChart.series.push(
          new am4plugins_wordCloud.WordCloudSeries()
        )
        series.randomness = 0.2
        series.rotationThreshold = 0.5

        series.data = item.data

        series.dataFields.word = 'tag'
        series.dataFields.idname = 'idname'
        series.dataFields.value = 'count'

        series.heatRules.push({
          target: series.labels.template,
          property: 'fill',
          min: am4core.color('#0000CC'),
          max: am4core.color('#CC00CC'),
          dataField: 'value',
        })

        if (chartParams?.templateUrl) {
          series.labels.template.url = !!chartParams?.templateUrl
            ? chartParams?.templateUrl
            : ROOT_URL + documentModel.getDefaultTopicURL();
        }

        const url = !!chartParams?.templateUrl
          ? chartParams?.templateUrl
          : ROOT_URL + documentModel.getDefaultTopicURL();
        // series.labels.template.urlTarget = '_blank'
        series.labels.template.tooltipText = '{word} : {value}'

        let hoverState = series.labels.template.states.create('hover')
        hoverState.properties.fill = am4core.color('#c00')

        let subtitle = thisChart.titles.create()
        subtitle.text = `( ${t('click to select')} )`
        subtitle.userClassName = 'custom-subtitle-chart'

        let title = thisChart.titles.create()
        title.text = t('choose topic')
        title.userClassName = 'custom-title-chart'

        // Add event listeners to labels
        if (!!!chartParams?.templateUrl && !!chartParams?.search_param) {
          series.labels.template.events.on("hit", function(ev) {
            // Prevent default action and stop propagation
            if (ev && ev.event) {
              ev.event.preventDefault();
              ev.event.stopPropagation();
              searchParams.set(chartParams?.search_param, decodeURIComponent(ev.target.currentText))
              history.replace(`${location.pathname}?${searchParams.toString()}${location.hash}`);
              // Custom action if needed
              console.log("Word clicked: ", ev.target.currentText);
            }
          });
        }

        addGlobalAmChartConfig(item, thisChart)

        addWatermarkLogoConfig(item, thisChart)

        break
      case 'ForceDirectedTree':
        thisChart = am4core.createFromConfig(
          {
            width: '100%',
            height: '100%',
            responsive: {
              enabled: true,
            },
            ...chartParams,
            tapToActivate: true,
            tapTimeout: 3000,
          },
          id,
          am4plugins_forceDirected.ForceDirectedTree
        )
        // thisChart = am4core.create(id, am4plugins_forceDirected.ForceDirectedTree);
        thisChart.padding(5, 5, 5, 5)
        thisChart.margin(5, 5, 5, 5)

        let networkSeries = thisChart.series.push(
          new am4plugins_forceDirected.ForceDirectedSeries()
        )
        networkSeries.dataFields.linkWith = 'linkWith'
        networkSeries.dataFields.name = 'name'
        networkSeries.dataFields.id = 'name'
        networkSeries.dataFields.value = 'value'
        networkSeries.dataFields.children = 'children'

        networkSeries.nodes.template.label.text = '{name}'
        networkSeries.fontSize = 8
        networkSeries.linkWithStrength = 0

        let nodeTemplate = networkSeries.nodes.template
        nodeTemplate.tooltipText = '{name}'
        nodeTemplate.fillOpacity = 1
        nodeTemplate.label.hideOversized = true
        nodeTemplate.label.truncate = true

        let linkTemplate = networkSeries.links.template
        linkTemplate.strokeWidth = 1
        let linkHoverState = linkTemplate.states.create('hover')
        linkHoverState.properties.strokeOpacity = 1
        linkHoverState.properties.strokeWidth = 2

        nodeTemplate.events.on('over', function (event) {
          let dataItem = event.target.dataItem
          dataItem.childLinks.each(function (link) {
            link.isHover = true
          })
        })

        nodeTemplate.events.on('out', function (event) {
          let dataItem = event.target.dataItem
          dataItem.childLinks.each(function (link) {
            link.isHover = false
          })
        })

        networkSeries.data = _.get(item, 'data', [])

        addGlobalAmChartConfig(item, thisChart)

        addWatermarkLogoConfig(item, thisChart)

        // thisChart.data = data_values;

        break
      case 'SunburstChart':
        thisChart = am4core.createFromConfig(
          {
            width: '100%',
            height: '100%',
            responsive: {
              enabled: true,
            },
            ...chartParams,
            tapToActivate: true,
            tapTimeout: 3000,
          },
          id,
          am4plugins_sunburst.Sunburst
        )
        thisChart.padding(0, 0, 0, 0)
        thisChart.margin(0, 0, 0, 0)
        thisChart.radius = am4core.percent(80)

        thisChart.colors.step = 2
        thisChart.fontSize = 11
        thisChart.innerRadius = am4core.percent(10)

        thisChart.dataFields.value = 'value'
        thisChart.dataFields.name = 'name'
        thisChart.dataFields.children = 'children'

        if (!chartParams?.seriesTemplates) {
          let level0SeriesTemplate = new am4plugins_sunburst.SunburstSeries()
          level0SeriesTemplate.hiddenInLegend = false
          thisChart.seriesTemplates.setKey('0', level0SeriesTemplate)

          // this makes labels to be hidden if they don't fit
          level0SeriesTemplate.labels.template.truncate = true
          level0SeriesTemplate.labels.template.hideOversized = true

          // level0SeriesTemplate.labels.template.adapter.add(
          //   'rotation',
          //   functions (
          //     rotation,
          //     target
          //   ) {
          //     target.maxWidth =
          //       target.dataItem.slice
          //         .radius -
          //       target.dataItem.slice
          //         .innerRadius -
          //       10
          //     target.maxHeight =
          //       Math.abs(
          //         ((target.dataItem
          //           .slice.arc *
          //           (target.dataItem
          //             .slice
          //             .innerRadius +
          //             target.dataItem
          //               .slice
          //               .radius)) /
          //           2) *
          //           am4core.math.RADIANS
          //       )

          //     return rotation
          //   }
          // )

          let level1SeriesTemplate = level0SeriesTemplate.clone()
          level1SeriesTemplate.fillOpacity = 0.75
          level1SeriesTemplate.hiddenInLegend = true
          thisChart.seriesTemplates.setKey('1', level1SeriesTemplate)

          let level2SeriesTemplate = level0SeriesTemplate.clone()
          level2SeriesTemplate.fillOpacity = 0.5
          level2SeriesTemplate.hiddenInLegend = true
          thisChart.seriesTemplates.setKey('2', level2SeriesTemplate)
        }

        thisChart.legend = new am4charts.Legend()
        if (!isSm) {
          thisChart.legend.maxWidth = 240
          thisChart.legend.position = 'right'
        } else {
          thisChart.legend.maxHeight = 50
        }
        // thisChart.legend.scrollable = true
        // thisChart.legend.valueLabels.template.disabled = true

        addGlobalAmChartConfig(item, thisChart)

        addWatermarkLogoConfig(item, thisChart)

        thisChart.data = data_values

        break
      default:
        break
    }
    if (thisChart) {
      if (thisChart.logo) {
        thisChart.logo.disabled = true
      }
      thisChart.svgContainer.autoResize = false
      thisChart.exporting.useWebFonts = false
      thisChart.tapToActivate = true
      thisChart.tapTimeout = 5000
      thisChart.dragGrip.disabled = false
      setChartWrap({
        getChart: () => thisChart,
        type: 'amchart',
      })
      setChart(thisChart)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    chart,
    id,
    item,
    // setChartWrap
  ])
  const predata = usePrevious(data)
  useEffect(() => {
    if (!item) return null
    const data_values = (() => {
      let data_values = item.data_values
      if (!!item.is_static_data) return data_values
      return data_values
    })()

    if (JSON.stringify(predata) !== JSON.stringify(data_values)) {
      setData(data_values)
    }
  }, [
    item.data_columns,
    item.data_encrypted,
    item.data_passphrase,
    item.data_values,
    predata,
  ])

  useEffect(() => {
    if (chart && data) {
      chart.data = data
      if (_.has(chart, 'series.0.data')) {
        chart.series[0].data = data
      }
      if (chart && chart.svgContainer && !!!chart.svgContainer.autoResize)
        chart.svgContainer.autoResize = true
    }
  }, [chart, data])
  useEffect(() => {
    return () => {
      if (chart) {
        setTimeout(() => chart.dispose())
      }
    }
  }, [chart])

  return useMemo(
    () => (
      <div
        className="flex-1"
        style={{
          width: '100%',
          height: '100%',
          // minHeight: '200px',
        }}
        id={id}
      />
    ),
    [id]
  )
}

export default AmChartStateless
